import { useCallback } from 'react';
import { useAppSelector } from '@/hooks';

// eslint-disable-next-line import/prefer-default-export
export const useHasUserDataError = () => {
  const errors = useAppSelector((state) => state.validation.errors);
  return useCallback((value) => errors.includes(value), [errors]);
};
